// `window.native` is the APP's namespace, installed by
// `installKarrotBridgeDriver()` from @daangn/karrotbridge. xview-perf only observes
// its readiness; it never invokes or writes to this namespace.
//
// The shape is declared structurally here instead of by importing the package,
// and that is a hard invariant of this module. A second karrotbridge module
// instance inside this bundle would:
//   - throw `getCurrentEnvironment is already installed.` synchronously from
//     `installFeature()` on the second `installKarrotBridgeDriver()` call,
//     killing the host page at boot;
//   - own a second message publisher, so every query issued through it stays
//     pending forever (plantae-plugin-auth awaits one before each HTTP
//     request — that is a white screen, not a lost metric);
//   - hand out operation ids from its own module-scope counter, so the two
//     copies would issue the same integers and silently cross-wire responses.
//
// Deliberately NOT a `declare global { interface Window { native } }`. That
// augmentation would land in the published .d.ts and merge with karrotbridge's
// own `native?: Native` in any app that imports both — and TypeScript requires
// merged property declarations to be identical, so it would break their build.
// The cast below keeps the assumption local to this file.
export interface NativeNamespace {
  // Readiness observation only; no callable contract is exposed.
  onQueried?: unknown;
  // Installed lazily by karrotbridge's `setGlobalMessageListener()` on the
  // app's FIRST bridge query. Native invokes it to deliver a response — a
  // response arriving before it exists is the
  // `native.onMessage is not a function` production error. Never called from
  // here; only its presence is observed.
  onMessage?: unknown;
}

// Reading a foreign global can throw (a getter installed by the host page, a
// revoked proxy after teardown). A performance library must never turn that
// into a page error.
export function readNativeNamespace(): NativeNamespace | undefined {
  try {
    return (window as { native?: NativeNamespace }).native;
  } catch {
    return undefined;
  }
}
